<script>
import { authComputed, setComputed } from '@store/helpers'
import { memberMenuListJtails } from "@src/config/menu";

export default {
  name:'Index8',
  page() {
    return {
      title: '會員中心',
    }
  },
  components: {
    Layout: () => import("@layout/main"),
    SectionMenu: () => import("./components/Index/SectionMenu"),
  },
  data() {
    return {
      menuList: Object.freeze(memberMenuListJtails())
    }
  },
  computed: {
    ...setComputed,
    ...authComputed,
  },
}
</script>
<!-- section template -->
<template>
  <Layout :class="$style.viewMember">
    <BaseBannerJtails
      title="會員中心"
      :image="require(`@assets/images/${$globalProjectName}/member/banner@2.jpg`)"
    />
    <SectionMenu
      :menu-list="menuList"
      center
    />
  </Layout>
</template>

<!-- section style -->
<style lang="scss" module>
.viewMember {
  :global {
    .viewMember {
      @include unstyled;
    }
  }
}
</style>





